import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";

export const DouyinGetCommentListParamsSchema = ActionCommonParamsSchema.extend({
    cursor: z.number().optional(),
    count: z.number().optional(),
    itemId: z.string(),
});

export type DouyinGetCommentListParams = z.infer<typeof DouyinGetCommentListParamsSchema>;
